import { defineComponent as n, inject as o, createElementBlock as r, openBlock as p, unref as t, normalizeClass as d, renderSlot as c } from "vue";
import { D as l } from "./DescriptionList.keys-BHlHYV6b.js";
const w = ["data-divide", "data-variant"], v = /* @__PURE__ */ n({
  __name: "DescriptionListGroup",
  setup(m) {
    const s = o(l.key);
    if (!s)
      throw new Error("DescriptionListDetail must be used within a DescriptionList component.");
    const { divide: i, variant: e } = s;
    return (a, u) => (p(), r("div", {
      class: d(["stash-description-list-group", {
        "md:tw-flex md:tw-gap-x-6": t(e) === "columns" || t(e) === "space-between",
        "tw-justify-between": t(e) === "space-between",
        "md:tw-flex": t(e) === "inline",
        "tw-py-1.5 first:tw-pt-0 last:tw-pb-0": !t(i),
        "tw-py-3 first:tw-pt-0 last:tw-pb-0": t(i)
      }]),
      "data-test": "stash-description-list-group",
      "data-divide": t(i),
      "data-variant": t(e)
    }, [
      c(a.$slots, "default")
    ], 10, w));
  }
});
export {
  v as default
};
//# sourceMappingURL=DescriptionListGroup.js.map
